





























import Vue from "vue";
import TeamsModule from "@/views/Team/TeamsModule";
import { getModule } from "vuex-module-decorators";

interface State {
  module: TeamsModule;
}

export default Vue.extend({
  name: "UserProfileDialog",
  props: {
    userId: { type: String, required: false }
  },
  methods: {
    close() {
      this.$emit("closeModal");
    }
  },
  computed: {
    iframeUrl() {
      return this.userId && `/user/edit/${this.userId}?hideNav=true`;
    }
  }
});
